import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {PrimaryButton, SecondaryButton} from "@sfly/uig-button";
import likesCommentOmnitureCalls from './../../../../redux/utils/likeCommentOmnitureCalls';

let modalRoot = document.getElementById("modal-root");

export default class DeleteConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement("div");
        this.state = {
            name: "",
            done: false
        };
        this._input;
    }

    componentWillMount() {
    }

    onClose = e => {
        // document.getElementsByTagName('body')[0].style.background = 'white';
        console.log("BUTTON CLICKED");
        e.stopPropagation();
        this.setState({done: false})
        this.props.onClose && this.props.onClose(e);
    };

    onClick = (action) => {
        if (action === 'cancel') {
            likesCommentOmnitureCalls.callOmniture('share-product:delete comment canceled');
        } else {
            likesCommentOmnitureCalls.callOmniture('share-product:delete comment confirm');
        }
        this.props.onAction(action);
    }


    onKeyUp = e => {
        // Lookout for ESC key (27)
        if (e.which === 27) {
            this.onClose(e);
        }
    };

    componentDidMount() {
        document.addEventListener("keyup", this.onKeyUp);
        if (modalRoot) {
            modalRoot.appendChild(this.el);
        } else {
            modalRoot = document.createElement("div");
            modalRoot.appendChild(this.el);
            document.getElementsByTagName("body")[0] &&
            document.getElementsByTagName("body")[0].appendChild(modalRoot);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.onKeyUp);
        if (modalRoot) {
            modalRoot.removeChild(this.el);
        }
    }


    render() {
        var modalUI = (
            <div className="delete-container">
                <div className="modal-share-delete">
                    <div className="modal-share-header inline-wrapper">
                        {/* <div
            key="close"
            className="sfly-share-header-close inline-div-one"
            onClick={this.onClick.bind(this, "close")}
          /> */}
                        <h3 className="margin-bottom-none inline-div-two">Delete this comment?</h3>
                    </div>
                    <div className="modal-share-content">
                        <div className="form-section">
                            <label className="share-pull-left">The action cannot be undone.</label>

                        </div>

                    </div>
                    <div className="button-wrapper">
                        <div className="button-save">
                            <div className="button-cancel" onClick={this.onClick.bind(this, "cancel")}>
                                <SecondaryButton>Cancel</SecondaryButton>
                            </div>
                            <div onClick={this.onClick.bind(this, "delete")}>
                                <PrimaryButton>Delete</PrimaryButton>
                            </div>


                        </div>


                    </div>
                    {/* <div className="modal-share-footer">
          {
            <div className="button-wrapper">
                <div className="button-save">
                   <div className="button-cancel" onClick={this.onClick.bind(this, "cancel")}>
                        <SecondaryButton> Cancel </SecondaryButton>
                    </div>
                    <div onClick={this.onClick.bind(this, "delete")}>
                    <PrimaryButton> Delete </PrimaryButton>
                    </div>
             
             
               </div>
          
      
          
            
          </div>
          }
        </div>
       */}
                </div>
            </div>
        );
        return ReactDOM.createPortal(modalUI, this.el);
    }
}

DeleteConfirmation.propTypes = {
    onAction: PropTypes.func.isRequired
};
